module.exports = __webpack_public_path__ + "img/34.a6318e35.jpg";